const FORM_STATE = {
  act: 'act',
  birthdate: 'birthdate',
  country: 'country',
  email: 'email',
  enrolltermyear: 'enrolltermyear',
  firstname: 'firstname',
  gpa: 'gpa',
  graduationyear: 'graduationyear',
  institutionName: 'institution_name',
  lastname: 'lastname',
  major: 'major',
  postal: 'postal',
  sat: 'sat',
  school: 'school',
  state: 'state',
  visitortype: 'visitortype',
  personalizationPreferences: 'personalization_preferences',
  personalizationSuggestions: 'personalization_suggestions',
};

export default FORM_STATE;
